import React from "react";
import { IAutomationChangeState } from "../../interfaces/IAutomation";
import { IAutomationCategory } from "../../interfaces/IAutomationCategory";
import { getTmpId } from "../core/generic_helpders";
import { Grid, MenuItem, Typography } from "@mui/material";
import { CustomeTextField } from "../core/CustomeTextField";
import { IOfferState } from "../../interfaces/IOfferState";
import { IProjectState } from "../../interfaces/IProjectState";
import { ITaskState } from "../../interfaces/ITaskState";
import { IBillState } from "../../interfaces/IBillState";

interface IProps {
    autoChangeState: IAutomationChangeState;
    setAutoChangeState: Function;
    autoCategoryArray: IAutomationCategory[];
    offerStateArray: IOfferState[];
    projectStateArray: IProjectState[];
    taskStateArray: ITaskState[];
    billStateArray: IBillState[];
}

export const getEmptyAutomationChangeState = (
    autoChangeStateArray: IAutomationChangeState[],
    idAutomation: number,
): IAutomationChangeState => {
    return {
        Automation: idAutomation,
        AutomationCategory: 1,
        BillState: null,
        id: getTmpId(autoChangeStateArray),
        OfferState: null,
        position: 1,
        ProjectState: 1,
        TaskState: null,
        activ_state_putback: false,
    };
};

export const AutomationChangeStateEdit: React.FC<IProps> = ({
    autoChangeState,
    setAutoChangeState,
    autoCategoryArray,
    offerStateArray,
    projectStateArray,
    taskStateArray,
    billStateArray,
}) => {
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <CustomeTextField
                        label="Bereich"
                        attr="AutomationCategory"
                        object={autoChangeState}
                        setObject={(updatedAuto: IAutomationChangeState) =>
                            setAutoChangeState({
                                ...updatedAuto,
                                TaskState: updatedAuto.AutomationCategory === 3 ? 1 : null,
                                ProjectState: updatedAuto.AutomationCategory === 1 ? 1 : null,
                                OfferState: updatedAuto.AutomationCategory === 2 ? 1 : null,
                                BillState: updatedAuto.AutomationCategory === 4 ? 10 : null,
                            })
                        }
                        type="select"
                    >
                        {autoCategoryArray.map((cat) => (
                            <MenuItem key={`select-send-category-${cat.id}`} value={cat.id}>
                                {cat.automationCategory}
                            </MenuItem>
                        ))}
                    </CustomeTextField>
                </Grid>

                <Grid item xs={4}>
                    <Typography sx={{ mt: 1 }}>Ändern auf Status:</Typography>
                </Grid>
                <Grid item xs={4}>
                    {autoChangeState.AutomationCategory === 1 ? (
                        <CustomeTextField
                            label="Status"
                            attr="ProjectState"
                            object={autoChangeState}
                            setObject={setAutoChangeState}
                            type="select"
                        >
                            {projectStateArray.map((x) => (
                                <MenuItem key={`select-auto-values-${x.id}`} value={x.id}>
                                    {x.projectState}
                                </MenuItem>
                            ))}
                        </CustomeTextField>
                    ) : autoChangeState.AutomationCategory === 2 ? (
                        <CustomeTextField
                            label="Status"
                            attr="OfferState"
                            object={autoChangeState}
                            setObject={setAutoChangeState}
                            type="select"
                        >
                            {offerStateArray.map((x) => (
                                <MenuItem key={`select-auto-values-${x.id}`} value={x.id}>
                                    {x.offerState}
                                </MenuItem>
                            ))}
                        </CustomeTextField>
                    ) : autoChangeState.AutomationCategory === 3 ? (
                        <CustomeTextField
                            label="Status"
                            attr="TaskState"
                            object={autoChangeState}
                            setObject={setAutoChangeState}
                            type="select"
                        >
                            {taskStateArray.map((x) => (
                                <MenuItem key={`select-auto-values-${x.id}`} value={x.id}>
                                    {x.taskState}
                                </MenuItem>
                            ))}
                        </CustomeTextField>
                    ) : autoChangeState.AutomationCategory === 4 ? (
                        <CustomeTextField
                            label="Status"
                            attr="BillState"
                            object={autoChangeState}
                            setObject={setAutoChangeState}
                            type="select"
                        >
                            {billStateArray.map((x) => (
                                <MenuItem key={`select-auto-values-${x.id}`} value={x.id}>
                                    {x.billState}
                                </MenuItem>
                            ))}
                        </CustomeTextField>
                    ) : (
                        <>Fehler!</>
                    )}
                </Grid>
                <Grid item xs={4}>
                    <CustomeTextField
                        label="Zurücksetzen erlauben"
                        attr="activ_state_putback"
                        object={autoChangeState}
                        setObject={setAutoChangeState}
                        type="boolean"
                    />
                </Grid>
            </Grid>
        </>
    );
};
